export { getTrustpilotReviews, getTrustpilotReviews as getReviews } from "./api/get-reviews";
export { default as useTrustpilotReviews } from "./hooks/use-trustpilot-reviews";
export { TrustpilotScoreContext, useTrustpilotScoreContext } from "./hooks/use-trustpilot-score-context";
